import { render, staticRenderFns } from "./TeamDashboardV2.vue?vue&type=template&id=20330262&scoped=true&"
import script from "./TeamDashboardV2.vue?vue&type=script&lang=ts&"
export * from "./TeamDashboardV2.vue?vue&type=script&lang=ts&"
import style0 from "./TeamDashboardV2.vue?vue&type=style&index=0&id=20330262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20330262",
  null
  
)

export default component.exports